import { Button } from '@/components/ui/button';
import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CTABanner = () => {
  return (
    <section className="bg-lime text-navy relative overflow-hidden border-y-[6px] border-navy">
      <div className="container mx-auto px-4 py-10 md:py-12 relative">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 text-center md:text-left">
          {/* Left — headline */}
          <div className="md:flex-1">
            <p className="font-display text-[11px] md:text-xs uppercase tracking-[0.28em] text-navy/80 mb-2 font-bold">
              Ready to Get Started?
            </p>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold uppercase leading-[1.02] text-navy">
              Free Estimate.{' '}
              <span className="text-white" style={{ textShadow: '2px 2px 0 hsl(var(--navy))' }}>
                Zero Pressure.
              </span>
            </h2>
          </div>

          {/* Right — CTA buttons */}
          <div className="flex flex-col sm:flex-row items-center gap-3 flex-shrink-0">
            <a href="tel:2016570855">
              <Button variant="hero" size="lg" className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-navy">
                <Phone className="w-4 h-4" />
                (201) 657-0855
              </Button>
            </a>
            <Link to="/contact">
              <Button variant="default" size="lg">
                Get Free Quote
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
